<div class="grid">
    <div class="col-12 md:col-6 xl:col-3 cursor-pointer" (click)="openSidebar()">
        <div class="ss-g-hover-border h-full flex-center" style="height: 160px !important;">
            <i class="pi pi-plus-circle text-5xl mb-2"></i>
            <span class="text-base font-medium">Adicionar</span>

        </div>

    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full" style="height: 160px !important;">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <div class="flex justify-content-between align-items-center">
                    <span class="font-semibold text-lg">
                        <i class="bi bi-grid-1x2-fill mr-2"></i> Widgets
                    </span>
                    <div class="ml-auto">
                        <i class="bi bi-info-circle" pTooltip="Quantidade de widgets cadastrados"
                            tooltipPosition="right"></i>
                    </div>
                </div>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{totalRecords}} </span>
                        <div class="text-green-500" style="height: 18px;">
                            <span class="font-medium">
                                <!-- <span *ngIf="percentageWatched == 0">
                                    -
                                </span> -->
                                <!-- <span *ngIf="percentageWatched > 0">
                                     +{{ percentageWatched | number:'1.0-2' }} <i class="pi pi-arrow-up"></i> 
                                </span> -->

                                <!-- Para porcentagem negativa -->
                                <!-- <span *ngIf="percentageWatched < 0">
                                     {{ percentageWatched | number:'1.0-2' }} <i class="pi pi-arrow-down"></i> 
                                </span> -->
                            </span>
                            <!-- <i *ngIf="(porcentagemAguardando ?? 0) > 0" class="pi pi-arrow-up text-xs ml-2"></i>
                            <i *ngIf="(porcentagemAguardando ?? 0) < 0" class="pi pi-arrow-down text-xs ml-2"></i> -->


                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full" style="height: 160px !important;">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <div class="flex justify-content-between align-items-center">
                    <span class="font-semibold text-lg">
                        <i class="bi bi-play-circle mr-2"></i> Slicks
                    </span>
                    <div class="ml-auto">
                        <i class="bi bi-info-circle" pTooltip="Quantidade de slicks associados aos widgets"
                            tooltipPosition="right"></i>
                    </div>
                </div>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{totalWidgets}}</span>

                        <div class="text-pink-500" style="height: 18px;">
                            <span class="font-medium">
                                <!-- <span *ngIf="percentageEspectadores == 0">
                                    -
                                </span> -->
                                <!-- <span *ngIf="percentageEspectadores > 0">
                                     +{{ percentageEspectadores | number:'1.0-2' }} <i class="pi pi-arrow-up"></i> 
                                </span> -->

                                <!-- Para porcentagem negativa -->
                                <!-- <span *ngIf="percentageEspectadores < 0">
                                     {{ percentageEspectadores | number:'1.0-2' }} <i class="pi pi-arrow-down"></i> 
                                </span> -->
                            </span>
                            <!-- <i *ngIf="(porcentagemExpiradas ?? 0) > 0" class="pi pi-arrow-up text-xs ml-2"></i>
                            <i *ngIf="(porcentagemExpiradas ?? 0) < 0" class="pi pi-arrow-down text-xs ml-2"></i> -->

                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full" style="height: 160px !important;">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <div class="flex justify-content-between align-items-center">
                    <span class="font-semibold text-lg">
                        <i class="bi bi-printer-fill mr-2"></i> Impressões
                    </span>
                    <div class="ml-auto">
                        <i class="bi bi-info-circle" pTooltip="Quantidade de usuarios que interagiram com os widgets"
                            tooltipPosition="left"></i>
                    </div>
                </div>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{totalPrints}}</span>
                        <div class="text-green-500" style="height: 18px;">
                            <span class="font-medium">
                                <span >
                                        
                                </span>
                                <span>
                                </span>

                                <!-- Para porcentagem negativa -->
                                <span>
                                </span>
                            </span>
                            <!-- <i *ngIf="(porcentagemCanceladas ?? 0) > 0" class="pi pi-arrow-up text-xs ml-2"></i>
                            <i *ngIf="(porcentagemCanceladas ?? 0) < 0" class="pi pi-arrow-down text-xs ml-2"></i> -->

                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
</div>
<div class="card">
    <p-table [value]="filteredWidgets" class="ss-l-table" dataKey="id" [paginator]="true" [rows]="10"
        [totalRecords]="totalRecords" [loading]="loading" [rowsPerPageOptions]="[10, 20, 100]" [sortMode]="'multiple'"
        [scrollable]="true">

        <ng-template pTemplate="caption">
            <div class="caption-container">
                <div class="left-section">
                </div>
                <div class="ss-g-right-section">
                    <div class="search-button-container" style="display: flex; align-items: center;">
                        <span class="p-input-icon-left mb-2 search-input" style="flex-grow: 1;">
                            <i class="pi pi-search"></i>
                            <input type="search" [(ngModel)]="searchTerm" pInputText
                                placeholder="Buscar por nome ou data" (input)="onFilterSlicks($event)"
                                style="width: 100%;">
                        </span>
                        <button #menuTarget pButton pRipple type="button" icon="pi pi-chevron-down" (click)="menu.toggle($event)" 
                            class="p-element p-ripple p-datepicker-trigger p-button-icon-only p-button p-component mb-2 menu-button"
                            style="margin-left: 0.5rem;"></button>
                        <p-menu #menu [model]="itemsButtons" [popup]="true" [ssClickOutsideMenu]="menu"
                        class="ss-g-custom-menu-right"></p-menu>
                    </div>
                </div>
            </div>
        </ng-template>


        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="title" class="centered-content-sales" style="width: 30%;">
                    Nome
                    <p-sortIcon field="title"></p-sortIcon>
                </th>
                <th pSortableColumn="page_type" class="centered-content-sales" style="width: 20%;">
                    Tipo de Página
                    <p-sortIcon field="page_type"></p-sortIcon>
                </th>
                <th pSortableColumn="template" class="centered-content-sales" style="width: 20%;">
                    Template
                    <p-sortIcon field="template"></p-sortIcon>
                </th>
                <th pSortableColumn="url_display" class="centered-content-sales" style="width: 25%;">
                    URL
                    <p-sortIcon field="url_display"></p-sortIcon>
                </th>
                <th class="centered-content-sales" style="width: 5%;">Ações</th>
            </tr>
            <tr>

                <th class="centered-content-sales" style="width: 50%;">
                    <p-columnFilter field="title" display="row" type="text" matchMode="contains"></p-columnFilter>
                </th>
                <th class="centered-content-sales">
                    <div style="display: flex; align-items: center; gap: 0.5rem; width: 100%;">
                        <p-dropdown [options]="pageTypeOptions" [(ngModel)]="selectedPageTypeFilter"
                            (ngModelChange)="applyFilter()" placeholder="Filtrar por tipo de página"
                            [style]="{'flex-grow': '1'}">
                            <ng-template let-option pTemplate="selectedItem">
                                <p-tag [severity]="getPageTypeSeverity(option.value)" [rounded]="true">
                                    {{ option.label }}
                                </p-tag>
                            </ng-template>
                            <ng-template let-option pTemplate="item">
                                <p-tag [severity]="getPageTypeSeverity(option.value)" [rounded]="true">
                                    {{ option.label }}
                                </p-tag>
                            </ng-template>
                        </p-dropdown>

                        <button *ngIf="selectedPageTypeFilter" pButton pRipple icon="pi pi-filter-slash"
                            class="p-button-text p-button-rounded" (click)="clearPageTypeFilter()"></button>
                    </div>
                </th>
                <th class="centered-content-sales">
                    <div style="display: flex; align-items: center; gap: 0.5rem; width: 100%;">
                        <p-dropdown [options]="templateOptions" [(ngModel)]="selectedTemplateFilter"
                            (ngModelChange)="applyFilter()" placeholder="Filtrar por template" [style]="{'flex-grow': '1'}">
                            <ng-template let-option pTemplate="selectedItem">
                                <p-tag [severity]="getTemplateSeverity(option.value)" [rounded]="true">
                                    {{ option.label }}
                                </p-tag>
                            </ng-template>
                            <ng-template let-option pTemplate="item">
                                <p-tag [severity]="getTemplateSeverity(option.value)" [rounded]="true">
                                    {{ option.label }}
                                </p-tag>
                            </ng-template>
                        </p-dropdown>

                        <button *ngIf="selectedTemplateFilter" pButton pRipple icon="pi pi-filter-slash"
                            class="p-button-text p-button-rounded" (click)="clearTemplateFilter()"></button>
                    </div>
                </th>
                <th class="centered-content-sales">
                    <p-columnFilter field="url_display" display="row" type="text" matchMode="contains"></p-columnFilter>
                </th>

                <th class="centered-content-sales" style="width: 5%;"></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-order>
            <tr *ngIf="!loading; else loadingContent">
                <td class="centered-content-sales cursor-pointer" (click)="editWidgets(order.uid)">
                    {{ order.title ?? 'Slick' }}
                </td>
                <td class="centered-content-sales text-center cursor-pointer" (click)="editWidgets(order.uid)">
                    <p-tag [severity]="getPageTypeSeverity(order.page_type)" [rounded]="true">
                        {{ getPageTypeLabel(order.page_type) }}
                    </p-tag>
                </td>
                <td class="cursor-pointer" (click)="editWidgets(order.uid)">
                    <p-tag [severity]="getTemplateSeverity(order.template)" [rounded]="true">
                        {{ getTemplateLabel(order.template) }}
                    </p-tag>
                </td>
                <td class="centered-content-sales">
                    <a *ngIf="order.url_display" [href]="order.url_display" target="_blank" rel="noopener noreferrer"
                        class="text-primary" (click)="$event.stopPropagation()">
                        {{ order.url_display }}
                    </a>
                    <span *ngIf="!order.url_display">-</span>
                </td>
                <td class="centered-content-sales">
                    <button pButton pRipple type="button" icon="pi pi-pencil"
                        (click)="menu.toggle($event); selectedWidget = order;"></button>
                    <p-menu #menu [model]="getActionMenu(selectedWidget)" [popup]="true" appendTo="body"></p-menu>
                </td>
            </tr>
            <ng-template #loadingContent>
                <tr>
                    <td colspan="4">
                        <p-skeleton width="100%" height="1rem"></p-skeleton>
                    </td>
                </tr>
            </ng-template>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">
                    <div class="flex flex-column align-items-center justify-content-center py-6 text-center w-full">
                        <i class="pi pi-th-large text-5xl text-primary mb-3" style="opacity: 0.6;"></i>
                        <span class="text-xl font-semibold text-900 mb-2">Nenhum widget criado ainda</span>
                        <span class="text-sm text-400 font-light mb-3" style="max-width: 400px;">Crie seu primeiro widget para exibir conteúdo interativo na sua loja.</span>
                        <button pButton pRipple icon="pi pi-plus" class="p-button-rounded" (click)="openSidebar()"></button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>

<p-dialog header="Aguarde" [(visible)]="displayAguarde" [modal]="true" [closable]="true" [showHeader]="true"
    [dismissableMask]="true" class="ss-g-dialog-sized">
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
</p-dialog>